import React from 'react'
import { AdOrderContext } from '../contexts/AdOrder'

export default function useGoToPayment () {

  const { adOrder, setAdOrder, restUrl, isLoading, setIsLoading } = React.useContext(AdOrderContext)

  const submit = function () {
    console.log('About to submit order', adOrder)

    setIsLoading(true)
    fetch(restUrl + adOrder.token, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ order: adOrder })
      }
    )
      .then(response => response.json())
      .then(response => {
        if (response?.success === true) {
          let order = response.data.order
          order.contact = response.data.contact
          order.payment = response.data.payment
          setAdOrder(order)
          if (response.data?.newLocation) {
            window.location = response.data.newLocation
          }
        }
      })
      .catch(() => {
        console.log('Update Order Error')
      })
      .finally(() => setIsLoading(false))
  }

  return {
    submit,
    isLoading
  }
}